// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { smallScaleMechanizationToolApi } from '../../lib/api';
import { type SmallScaleMechanizationTool } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/small-scale-mechanization/';

export default (props: PageProps) => {
  const [data: SmallScaleMechanizationTool, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await smallScaleMechanizationToolApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: SmallScaleMechanizationTool) => {
    let id = payload.id;
    if (id) {
      await smallScaleMechanizationToolApi.update(payload);
    } else {
      let data = await smallScaleMechanizationToolApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: SmallScaleMechanizationTool) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Средства малой механизации'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
